import * as React from "react";
import { forwardRef } from "react";
const SvgBackToIcon = (props, ref) => /* @__PURE__ */ React.createElement("svg", { fill: "none", height: 20, viewBox: "0 0 20 20", width: 20, xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m18 10h-16m0 0 8 8m-8-8 8-8", stroke: "#2c2d32", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.3 }));
const ForwardRef = forwardRef(SvgBackToIcon);
export default ForwardRef;
